import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Heart, Brain, Users, Shield, CheckCircle, Star } from 'lucide-react';

const Home = () => {
  return (
    <div className="home-page" data-testid="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-announcement">
              <Star size={14} fill="currentColor" />
              <span>Centro Psicológico Especializado</span>
            </div>
            
            <h1 className="heading-hero">
              Tu Bienestar Mental es Nuestra Prioridad
            </h1>
            
            <p className="hero-subtitle body-large">
              Acompañamiento profesional en cada etapa de tu vida. 
              Terapia personalizada con especialistas certificados.
            </p>
            
            <div className="hero-actions">
              <a
                href="https://wa.me/51934442759"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                data-testid="hero-agendar-cita"
              >
                AGENDAR CITA
              </a>
              <Link to="/nosotros" className="btn-secondary" data-testid="hero-conocer-equipo">
                CONOCER EQUIPO
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="trust-indicators">
              <div className="trust-item">
                <CheckCircle size={20} className="trust-icon" />
                <span>Psicólogos Certificados</span>
              </div>
              <div className="trust-item">
                <CheckCircle size={20} className="trust-icon" />
                <span>Atención Personalizada</span>
              </div>
              <div className="trust-item">
                <CheckCircle size={20} className="trust-icon" />
                <span>Confidencialidad Garantizada</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">¿Por Qué Elegirnos?</h2>
            <p className="body-large">Comprometidos con tu salud mental y bienestar emocional</p>
          </div>

          <div className="why-grid">
            <div className="why-card">
              <div className="why-icon accent-teal">
                <Heart size={28} />
              </div>
              <h3 className="heading-3">Enfoque Humano</h3>
              <p className="body-medium">
                Tratamiento personalizado centrado en tus necesidades y objetivos específicos.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon accent-teal">
                <Brain size={28} />
              </div>
              <h3 className="heading-3">Especialización</h3>
              <p className="body-medium">
                Equipo multidisciplinario con amplia experiencia en diversas áreas de la psicología.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon accent-teal">
                <Users size={28} />
              </div>
              <h3 className="heading-3">Atención Integral</h3>
              <p className="body-medium">
                Desde terapia individual hasta interconsultas psiquiátricas y neuropsicología.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon accent-teal">
                <Shield size={28} />
              </div>
              <h3 className="heading-3">Confidencialidad</h3>
              <p className="body-medium">
                Tu información y proceso terapéutico están protegidos bajo estricta confidencialidad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Nuestros Servicios</h2>
            <p className="body-large">Atención especializada para todas las etapas de la vida</p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-content">
                <h3 className="heading-3">Terapia Individual</h3>
                <p className="body-small">Atención personalizada para adultos, adolescentes y niños. Tratamiento de ansiedad, depresión, estrés y otros trastornos emocionales.</p>
              </div>
            </div>
            
            <div className="service-card">
              <div className="service-content">
                <h3 className="heading-3">Terapia de Pareja</h3>
                <p className="body-small">Fortalecimiento de vínculos, resolución de conflictos y mejora de la comunicación en las relaciones de pareja.</p>
              </div>
            </div>
            
            <div className="service-card">
              <div className="service-content">
                <h3 className="heading-3">Terapia Familiar</h3>
                <p className="body-small">Abordaje sistémico para resolver conflictos familiares y mejorar la dinámica del hogar.</p>
              </div>
            </div>
            
            <div className="service-card">
              <div className="service-content">
                <h3 className="heading-3">Psicología Infantil</h3>
                <p className="body-small">Tratamiento especializado en trastornos del neurodesarrollo, problemas de conducta y aprendizaje.</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <Link to="/servicios" className="btn-primary">
              VER TODOS LOS SERVICIOS
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Lo Que Dicen Nuestros Pacientes</h2>
            <p className="body-large">Historias reales de transformación y bienestar</p>
          </div>

          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-rating">
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
              </div>
              <p className="testimonial-text body-medium">"La atención que recibí fue excepcional. Me ayudaron a superar mi ansiedad y ahora tengo herramientas para manejar el estrés diario."</p>
              <p className="testimonial-author caption">- María G.</p>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-rating">
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
              </div>
              <p className="testimonial-text body-medium">"El equipo de Mind Life es muy profesional. La terapia de pareja salvó mi relación. Totalmente recomendado."</p>
              <p className="testimonial-author caption">- Carlos R.</p>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-rating">
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
                <Star size={16} fill="#00A489" color="#00A489" />
              </div>
              <p className="testimonial-text body-medium">"Mi hijo ha mejorado muchísimo con la terapia infantil. Las psicólogas son muy cálidas y profesionales."</p>
              <p className="testimonial-author caption">- Ana L.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1">Da el Primer Paso Hacia tu Bienestar</h2>
            <p className="body-large">
              Agenda tu cita hoy y comienza tu proceso de transformación con nuestro equipo de especialistas.
            </p>
            <a
              href="https://wa.me/51934442759"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary large"
            >
              CONTACTAR POR WHATSAPP
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
